<div class="car-image">
  <div class="car-image-main">
    @if (carImagesFolder?.length! < 1) {
      <p class="spinner">
        <mat-spinner style="margin:0 auto;"  [diameter]="35"></mat-spinner>
      </p>
    }

    <img [src]="(currentImage != undefined) ? currentImage : 'assets/images/car_image_holder.png'" alt="Car Image"
      (click)="nextImage()">

      <div class = "img-arrow-container">
        <button [disabled]="!(carImagesFolder != undefined && carImagesFolder!.length > 1)" mat-button (click)="prevImage();$event.stopPropagation()" class="pic-arrow-left"><mat-icon>arrow_back_ios</mat-icon></button>
        <button [disabled]="!(carImagesFolder != undefined && carImagesFolder!.length > 1)" mat-button (click)="nextImage();$event.stopPropagation()" class="pic-arrow-right"><mat-icon>arrow_forward_ios</mat-icon></button>
      </div>

      @if ((carImagesFolder != undefined && carImagesFolder!.length > 0)) {
        <div class = "img-counter">
          {{ currentImageIndex + 1 }}/{{ carImagesFolder!.length }}
        </div>
      }
    </div>

    @if (showThumbnails) {
      <div class="car-image-thumbs">
        @for (file of (carImagesFolder$ | async)  ; track file; let i = $index) {
          <div class="image-thumb"
            [style.border-color]=" (i===currentImageIndex) ? 'lightgray': 'white'">
            <!-- <p class="spinner" *ngIf="carImagesFolder?.length! < 1 && car.imagesFilenames?.length! > 0">
            <mat-spinner style="margin:0 auto;"  [diameter]="35"></mat-spinner>
          </p>  -->
          <!-- <img mat-card-image [src]= "(currentImage != undefined) ? currentImage : 'assets/images/car_image_holder.png'" alt="Car Image">
          -->
          <!-- <img src= "assets/images/car_image_holder.png" alt="Car Image"> -->
          <img mat-card-image
            [src]="((carImagesFolder$ | async)?.length! > 0) ? getCarImage(i) : 'assets/images/car_image_holder.png'" alt="Car Image"
            (click)="selectImage(i)"
            >
          </div>
        }
      </div>
    }

  </div>